import * as React from 'react';
import * as RPNInput from 'react-phone-number-input';
import { cn } from '../../utils';
import { CountrySelect } from './CountrySelect';
import { FlagComponent } from './FlagComponent';
import { InputComponent } from './InputComponent';
import { CountrySelectProps, PhoneInputProps } from './types';

export const PhoneInput: React.ForwardRefExoticComponent<PhoneInputProps> =
  React.forwardRef<React.ElementRef<typeof RPNInput.default>, PhoneInputProps>(
    (
      {
        className,
        onChange,
        value,
        countrySearchPlaceholder,
        countryNotFoundText,
        ...props
      },
      ref
    ) => {
      const CustomCountrySelect = React.useCallback(
        (selectProps: CountrySelectProps) => (
          <CountrySelect
            {...selectProps}
            searchPlaceholder={countrySearchPlaceholder}
            notFoundText={countryNotFoundText}
          />
        ),
        [countrySearchPlaceholder, countryNotFoundText]
      );

      return (
        <RPNInput.default
          ref={ref}
          className={cn('flex [&>div]:w-full', className)}
          flagComponent={FlagComponent}
          countrySelectComponent={CustomCountrySelect}
          inputComponent={InputComponent}
          smartCaret={false}
          value={value || undefined}
          /**
           * Handles the onChange event.
           *
           * react-phone-number-input might trigger the onChange event as undefined
           * when a valid phone number is not entered. To prevent this,
           * the value is coerced to an empty string.
           *
           * @param {E164Number | undefined} value - The entered value
           */
          onChange={value => onChange?.(value || ('' as RPNInput.Value))}
          {...props}
        />
      );
    }
  );

PhoneInput.displayName = 'PhoneInput';
